<div class="row">
<div class="col-sm-4 col-md-3 col-xl-1 space" *ngFor="let data of contactData; first as isFirst;">
<div class="uil-card-span-4 uil-card-template card-width" [class]="isFirst? 'zero-margin': 'some-margin'">
  <div class="uil-card-banner uil-noborder">
    <div class="top-banner">
      <img
        src="../../../assets/images/Soft-Plat.svg"
        width="70"
        height="70"
        style="margin-top: 25px"
      />
    </div>
  </div>
  <div class="card-content">
    <div class="lead-name" 
    style="cursor: pointer" 
    [title]="peoplePageTooltip"
    (click)="navigateToPeoplePage(data.EID)">
      {{ data.Contact_Name }}
    </div>
    <h5 class="lead-industry">{{ data.Industry }}</h5>
    <p class="subDetails">{{ data.Level }}</p>
    <hr />
  </div>

  <div class="uil-card-footer">
    <div class="uil-card-footer-icon-area" style="justify-content: center">
      <div class="icon-container">
        <span
          class="uil-dl-icon-Envelope-alt envelope-icon"
          [title]="envelopeTooltip"
          style="cursor: pointer"
          (click)="sendMail(data.EID)"
        ></span>
        <a style="color: #393a3e; cursor: pointer"
        ><span class="uil-icon-Chat-alt chat-icon" 
        [title]="teamsTooltip"
        (click)="teamsNavigate(data.EID)"></span
        ></a>
      </div>
    </div>
  </div>
</div>
</div>
</div>
